import { Grid } from "@material-ui/core";
import React from "react";
import "./Projects.scss";
import { Text, Input, Button, TextArea, SelectBox } from "sunrise-ui";
//------for api call------
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import {
  postCreateFinancialData,
  putFinancialData,
} from "../../redux/reducers/projectReducers";
import { uiSliceActions } from "../../redux/reducers/uiState";
import { getProjectFinancialData } from "../../redux/reducers/projectReducers";
import Loader from "../../utilities/Loader";
import { amountRegex } from "../../utilities/regx";

const validaiator = (state: any, action: any) => {
  switch (action.type) {
    case "projectName":
      return { ...state, projectName: action.payload, projectNameErr: false };
    case "projectNameErr":
      return { ...state, projectNameErr: action.payload };
    case "month":
      return { ...state, month: action.payload, monthErr: false };
    case "monthErr":
      return { ...state, monthErr: action.payload };
    case "year":
      return { ...state, year: action.payload, yearErr: false };
    case "yearErr":
      return { ...state, yearErr: action.payload };
    case "totalPaymentReceived":
      return {
        ...state,
        totalPaymentReceived: action.payload,
        totalPaymentReceivedErr: false,
      };
    case "totalPaymentReceivedErr":
      return { ...state, totalPaymentReceivedErr: action.payload };
    case "totalBillingDone":
      return {
        ...state,
        totalBillingDone: action.payload,
        totalBillingDoneErr: false,
      };
    case "totalBillingDoneErr":
      return { ...state, totalBillingDoneErr: action.payload };
    case "overallWorkDone":
      return {
        ...state,
        overallWorkDone: action.payload,
        overallWorkDoneErr: false,
      };
    case "overallWorkDoneErr":
      return { ...state, overallWorkDoneErr: action.payload };
    case "reset":
      return { ...initialState };
    default:
      return { ...state, description: action.payload };
  }
};

//----initial State of form---
const initialState = {
  projectName: "",
  projectNameErr: false,
  month: "",
  monthErr: false,
  year: "",
  yearErr: false,
  totalPaymentReceived: "",
  totalPaymentReceivedErr: false,
  totalBillingDone: "",
  totalBillingDoneErr: false,
  overallWorkDone: "",
  overallWorkDoneErr: false,
  description: "",
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const ProjectFinancialInfo = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  let [loadingBtn, setLoadingBtn] = React.useState(false);

  //---to get all projects detail----
  React.useEffect(() => {
    setLoading(true);
    dispatch(getAllProjectData({ endPoint: "project/get-all-projects" })).then(
      (res) => {
        setLoading(false);
      }
    );
  }, [dispatch]);
  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );
  const projectSelectBoxData: [] =
    allProjectData &&
    allProjectData?.map((item: any) => {
      return item?.projectName;
    });

  const createFinancialData = useSelector(
    (state: any) => state.PROJECT.createFinancialData
  );
  const updateFinancialData = useSelector(
    (state: any) => state.PROJECT.updateFinancialData
  );
  //---to get edit data--
  const editData = useSelector(
    (state: any) => state.SPECIFICPROJECT.financialEdit
  );

  //-----initial state and reducer----
  const [state, dispatchState] = React.useReducer(validaiator, initialState);
  const [projectId, setProjectId] = React.useState("");
  const changeResetProjectName = () => { };
  const changeResetmonth = () => { };

  //-------handle Submit----
  const handleSubmit = () => {
    if (loadingBtn === false) {
      let goodToGo = true;
      for (const [key, value] of Object.entries(state)) {
        if (key !== "description" && value === "") {
          dispatchState({ type: `${key}Err`, payload: true });
          goodToGo = false;
        }
        if ((key === "totalPaymentReceivedErr" || key === "totalBillingDoneErr" || key === "overallWorkDoneErr") && value === true) {
          goodToGo = false;
        }
      }
      if (goodToGo === true) {
        // ---create param and call API---
        // console.log(new Date(`${state?.month.toLowerCase()} 1, ${state?.year}`));
        let myObj = {
          projectName: state?.projectName,
          projectId: projectId,
          month: state?.month.toLowerCase(),
          year: state?.year,
          totalPaymentReceived: Number(state?.totalPaymentReceived),
          totalBillingDone: Number(state?.totalBillingDone),
          overallWorkDone: Number(state?.overallWorkDone),
          billDate: new Date(`${state?.month.toLowerCase()} 1, ${state?.year} 05:30:00`),
          description: state?.description,
        };
        if (editData?.type === "edit") {
          setLoadingBtn(true);
          dispatch(
            putFinancialData({
              endPoint: `project-finance/update-project-fin/${editData?.financialInfoId}`,
              data: myObj,
            })
          ).then((res) => {
            setLoadingBtn(false);
          });
        } else {
          setLoadingBtn(true);
          dispatch(
            postCreateFinancialData({
              endPoint: "project-finance/create-project-fin",
              data: myObj,
            })
          ).then((res) => {
            setLoadingBtn(false);
          });
        }
      }
    }
  };

  //------handle cancel--------
  const handleCancel = () => {
    dispatchState({ type: "reset", payload: "" });
    setProjectId("");
    dispatch(uiSliceActions.setInitialFinancialEdit());
  };
  React.useEffect(() => {
    if (createFinancialData?.status || updateFinancialData?.status) {
      dispatch(
        getProjectFinancialData({
          endPoint: "project-finance/get-all-project-fin",
        })
      );
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createFinancialData, updateFinancialData]);
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  //---for project edit--
  React.useEffect(() => {
    if (editData?.type === "edit") {
      dispatchState({
        type: "projectName",
        payload: editData?.projectDetail?.projectName,
      });
      dispatchState({
        type: "month",
        payload: capitalizeFirstLetter(editData?.projectDetail?.month),
      });
      dispatchState({
        type: "year",
        payload: editData?.projectDetail?.year,
      });
      dispatchState({
        type: "totalPaymentReceived",
        payload: editData?.projectDetail?.totalPaymentReceived,
      });
      dispatchState({
        type: "totalBillingDone",
        payload: editData?.projectDetail?.totalBillingDone,
      });
      dispatchState({
        type: "overallWorkDone",
        payload: editData?.projectDetail?.overallWorkDone,
      });
      dispatchState({
        type: "description",
        payload: editData?.projectDetail?.description,
      });
      setProjectId(editData?.projectDetail?.projectId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);

  //---------------------For reset-------------------------------------------
  const handleChange = () => {
    dispatchState({
      type: "totalPaymentReceived",
      payload: "",
    });
    dispatchState({
      type: "totalBillingDone",
      payload: "",
    });
    dispatchState({
      type: "overallWorkDone",
      payload: "",
    });
  };

  const generateYearList = () => {
    const currentYear = new Date().getFullYear();
    const yearList = [];
    for (let i = -20; i <= 20; i++) {
      yearList.push(currentYear + i);
    }
    return yearList;
  }

  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid
          container
          className="financialInfo_wrapper box--shadow bg--white p1 mt1"
        >
          <Grid item xs={12} container spacing={2}>
            {/* ----------Project input----- */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0"
              >
                <span className="fw500">Select Project*</span>
              </Text>
              <SelectBox
                data={[...projectSelectBoxData]}
                placeHolder="Select Project"
                defaultVal={state?.projectName}
                onChange={(e) => {
                  let target = { ...e };
                  dispatchState({
                    type: "projectName",
                    payload: target?.target?.value,
                  });
                  const index = projectSelectBoxData
                    ?.map((item: any) => item)
                    .indexOf(target.target.value);
                  setProjectId(allProjectData && allProjectData[index]?._id);
                  dispatchState({
                    type: "month",
                    payload: "",
                  });
                  dispatchState({
                    type: "year",
                    payload: "",
                  });
                  handleChange();
                }}
                borderColor={state?.projectNameErr ? "danger" : "primary"}
                name="projectName"
                resetVal={state?.projectName?.toString() === "" ? true : false}
                changeReset={changeResetProjectName}
              />
              <Text
                type={state?.projectNameErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={
                  state?.projectNameErr ? "mb0 mt0 float-right" : "d-none"
                }
              >
                Please Select Project Name.
              </Text>
            </Grid>
            {/* ----------month input----- */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0"
              >
                <span className="fw500">Select Month*</span>
              </Text>
              <SelectBox
                data={[...months]}
                placeHolder="Select Month"
                defaultVal={state?.month}
                onChange={(e) => {
                  let target = { ...e };
                  dispatchState({
                    type: "month",
                    payload: target?.target?.value,
                  });
                  handleChange();
                }}
                borderColor={state?.monthErr ? "danger" : "primary"}
                name="month"
                resetVal={state?.month?.toString() === "" ? true : false}
                changeReset={changeResetmonth}
              />
              <Text
                type={state?.monthErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={state?.monthErr ? "mb0 mt0 float-right" : "d-none"}
              >
                Please Select Month Name.
              </Text>
            </Grid>

            {/* ----------year input----- */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0"
              >
                <span className="fw500">Select Year*</span>
              </Text>
              <SelectBox
                data={generateYearList()}
                placeHolder="Select Year"
                defaultVal={state?.year}
                onChange={(e) => {
                  let target = { ...e };
                  dispatchState({
                    type: "year",
                    payload: target?.target?.value,
                  });
                  handleChange();
                }}
                borderColor={state?.yearErr ? "danger" : "primary"}
                name="year"
                resetVal={state?.year?.toString() === "" ? true : false}
                changeReset={changeResetmonth}
              />
              <Text
                type={state?.yearErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={state?.yearErr ? "mb0 mt0 float-right" : "d-none"}
              >
                Please Select Year Name.
              </Text>
            </Grid>

          </Grid>
          <Grid item xs={12} container spacing={2}>
            {/* ----------Total payment Recieved------ */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt1"
              >
                <span className="fw500">Payment Received (Rs)*</span>
              </Text>
              <Input
                color={state?.totalPaymentReceivedErr ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                name="totalPaymentReceived"
                value={state?.totalPaymentReceived}
                min={1}
                type="number"
                onChange={(e) => {
                  if (
                    // Number(e?.target?.value) < 0 ||
                    // Number(e?.target?.value?.length) > 12
                    e.target.value === "" ||
                    amountRegex.test(e.target.value)
                  ) {
                    dispatchState({
                      type: "totalPaymentReceived",
                      payload: e.target.value,
                    });
                    dispatchState({
                      type: "totalPaymentReceivedErr",
                      payload: false,
                    });
                  }

                  if (Number(e?.target?.value) <= 0) {
                    dispatchState({
                      type: "totalPaymentReceivedErr",
                      payload: true,
                    });
                  }

                }}
              />
              <Text
                type={state?.totalPaymentReceivedErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={
                  state?.totalPaymentReceivedErr
                    ? "mb0 mt0 float-right"
                    : "d-none"
                }
              >
                Please Enter Payment Recieved.
              </Text>
            </Grid>
            {/* ----------Total Billing Done------ */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt1"
              >
                <span className="fw500">Billing Done (Rs)*</span>
              </Text>
              <Input
                color={state?.totalBillingDoneErr ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                name="totalBillingDone"
                value={state?.totalBillingDone}
                min={1}
                type="number"
                onChange={(e) => {
                  if (
                    // Number(e?.target?.value) < 0 ||
                    // Number(e?.target?.value?.length) > 12
                    e.target.value === "" ||
                    amountRegex.test(e.target.value)
                  ) {
                    dispatchState({
                      type: "totalBillingDone",
                      payload: e.target.value,
                    });
                    dispatchState({
                      type: "totalBillingDoneErr",
                      payload: false,
                    });
                  }

                  if (Number(e?.target?.value) <= 0) {
                    dispatchState({
                      type: "totalBillingDoneErr",
                      payload: true,
                    });
                  }
                }}
              />
              <Text
                type={state?.totalBillingDoneErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={
                  state?.totalBillingDoneErr ? "mb0 mt0 float-right" : "d-none"
                }
              >
                Please Enter Billing Done.
              </Text>
            </Grid>
            {/* ----------Overall Work Done------ */}
            <Grid item xs={4}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt1"
              >
                <span className="fw500"> Work Done (Rs)*</span>
              </Text>
              <Input
                color={state?.overallWorkDoneErr ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                name="overallWorkDone"
                value={state?.overallWorkDone}
                min={1}
                type="number"
                onChange={(e) => {
                  if (
                    // Number(e?.target?.value) < 0 ||
                    // Number(e?.target?.value?.length) > 12
                    e.target.value === "" ||
                    amountRegex.test(e.target.value)
                  ) {
                    dispatchState({
                      type: "overallWorkDone",
                      payload: e.target.value,
                    });
                    dispatchState({
                      type: "overallWorkDoneErr",
                      payload: false,
                    });
                  }

                  if (Number(e?.target?.value) <= 0) {
                    dispatchState({
                      type: "overallWorkDoneErr",
                      payload: true,
                    });
                  }
                }}
              />
              <Text
                type={state?.overallWorkDoneErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={
                  state?.overallWorkDoneErr ? "mb0 mt0 float-right" : "d-none"
                }
              >
                Please Enter Work Done.
              </Text>
            </Grid>
            {/* -----------description--------- */}
            <Grid item xs={4} className="text_area">
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0"
              >
                <span className="fw500">Description</span>
              </Text>
              <TextArea
                name="description"
                value={state.description}
                maxLength={100}
                onChange={(e) => {
                  dispatchState({
                    type: "description",
                    payload: e.target.value,
                  });
                }}
                placeholder="Write description here"
              />
            </Grid>
          </Grid>
          {/* -----------submit/Cancel---------- */}
          <Grid item xs={12} container>
            <Button
              type="button"
              size="medium"
              isRounded={true}
              category="primary"
              onClick={() => {
                handleSubmit();
              }}
              className="submit_button mb1 mt1 mr-1 pl pr"
            >
              {loadingBtn ? (
                <Loader
                  color="#fff"
                  loading={loadingBtn}
                  size={8}
                  height="auto"
                />
              ) : (
                "Submit"
              )}
            </Button>
            <Button
              type="button"
              size="medium"
              isRounded={true}
              category="border-only"
              onClick={() => {
                handleCancel();
              }}
              className="submit_button mb1 mt1 pl pr"
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ProjectFinancialInfo;
